import { render } from "./report-propaganda.vue?vue&type=template&id=1d7017c8&scoped=true"
import script from "./report-propaganda.vue?vue&type=script&lang=js"
export * from "./report-propaganda.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d7017c8"]])

export default __exports__